/**
 * Every printer portal read and write (product spec 3 APIs). Built from the
 * scope root, so an own-login path always starts with `/printer-portal/`.
 * View-as (internal) mounts only the reads; the screens never offer writes there.
 */
import { apiRoot } from "../lib/scope.ts";
import type { PortalScope } from "../types.ts";

const e = encodeURIComponent;

export function printerPortalPaths(scope: PortalScope) {
  const root = apiRoot(scope);
  const part = (id: string) => `${root}/printer-orders/${e(id)}`;
  return {
    bootstrap: `${root}/bootstrap`,
    summary: `${root}/summary`,
    counts: `${root}/column-counts`,
    board: `${root}/board`,
    schedule: `${root}/schedule`,
    workOn: `${root}/work-on`,
    workOnBulk: `${root}/work-on/bulk`,
    order: part,
    stage: (id: string) => `${part(id)}/stage`,
    confirmBlanks: (id: string) => `${part(id)}/confirm-blanks`,
    files: (id: string) => `${part(id)}/files`,
    file: (id: string, uploadId: string) => `${part(id)}/files/${e(uploadId)}`,
    designZip: (id: string) => `${part(id)}/design.zip`,
  };
}
